import { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";

const moduleSelector = (state: IRootState) => state.achievements;

export const getAchievements = createSelector(moduleSelector, state => state.achievements);
export const getAchievementsError = createSelector(moduleSelector, state => state.achievementsError);
export const getAchievementsIsLoading = createSelector(moduleSelector, state => state.achievementsIsLoading);

export const getAchievementsPreview = createSelector(moduleSelector, state => state.achievementsPreview);
export const getAchievementsPreviewError = createSelector(moduleSelector, state => state.achievementsPreviewError);
export const getAchievementsPreviewIsLoading = createSelector(moduleSelector, state => state.achievementsPreviewIsLoading);

export const getAchievementsProgress = createSelector(moduleSelector, state => state.achievementsProgress);
export const getAchievementsProgressError = createSelector(moduleSelector, state => state.achievementsProgressError);
export const getAchievementsProgressIsLoading = createSelector(moduleSelector, state => state.achievementsProgressIsLoading);
